import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useBffClient } from './client';
import type { OrgSwitcherItem, Organization, Member, Invitation, License } from '../types/organization';
import type { CreateInvitationRequest } from '../types/settings';

export function useMyOrganizations() {
  const client = useBffClient();
  return useQuery({
    queryKey: ['organizations', 'mine'],
    queryFn: () => client.get<OrgSwitcherItem[]>('/bff/organizations/mine'),
  });
}

export function useCurrentOrg() {
  const client = useBffClient();
  return useQuery({
    queryKey: ['organizations', 'current'],
    queryFn: () => client.get<Organization>('/bff/organizations/current'),
  });
}

export function useOrgMembers() {
  const client = useBffClient();
  return useQuery({
    queryKey: ['organizations', 'members'],
    queryFn: () => client.get<Member[]>('/bff/organizations/current/members'),
  });
}

export function useOrgInvitations() {
  const client = useBffClient();
  return useQuery({
    queryKey: ['organizations', 'invitations'],
    queryFn: () => client.get<Invitation[]>('/bff/organizations/current/invitations'),
  });
}

export function useOrgLicense() {
  const client = useBffClient();
  return useQuery({
    queryKey: ['organizations', 'license'],
    queryFn: () => client.get<License>('/bff/organizations/current/license'),
  });
}

export function useCreateInvitation() {
  const client = useBffClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: CreateInvitationRequest) =>
      client.post('/bff/organizations/current/invitations', request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations', 'invitations'] });
    },
  });
}
